module.exports = __webpack_public_path__ + "media/icons/chat-alt-2-92a5af03.svg";